import { useState } from 'react';
import { useAsyncEffect } from 'ahooks';
import { v4 } from 'uuid';
import { request } from '@shakkerai/services';

export const pageSize = 20;

export const useCateListFetch = (menuPath, collectState) => {
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);
  const [hasMore, setHasMore] = useState(true); // 到底了

  const fetchList = async (params) => {
    try {
      const res = await request('/api/canva/model/collection', params);
      if (res.code === 0) {
        return {
          list: res.data.data,
          total: res.data.total,
          page: params.page,
          requestId: params.requestId,
        };
      } else {
        console.log('接口异常');
        return null;
      }
    } catch (err) {
      console.log(err);
      return null;
    }
  };

  useAsyncEffect(async () => {
    setLoading(true);
    setHasMore(true);
    const result = await fetchList({
      page: 1,
      pageSize,
      collectionId: collectState.data.id,
      requestId: v4(),
    });
    setList(result);
    setLoading(false);
  }, [menuPath]);
  return { loading, fetchList, list, setList, hasMore, setHasMore };
};
